import { Injectable } from "@angular/core";
import { Role } from '../../lib/rbac.config';
import { MatDialog } from "@angular/material/dialog";

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(private dialog: MatDialog) { }
    
    isLoggedIn(): boolean{
        return localStorage.getItem('sessionId') !== null;
    }


    getRole(): Role {
        const raw = (localStorage.getItem('accountType') ?? '').trim().toLowerCase();
        switch (raw) {
            case 'super admin': return Role.SUPER_ADMIN;
            case 'admin':       return Role.ADMIN;
            case 'operations':  return Role.OPERATIONS;
            case 'audit':       return Role.AUDIT;
            case 'marketing':   return Role.MARKETING;
            case 'accounting':  return Role.ACCOUNTING;
            default:            return Role.NONE;
        }
    }

    isAdmin(): boolean {
        const role = this.getRole();
        return role === Role.SUPER_ADMIN || role === Role.ADMIN || role === Role.OPERATIONS;
    }

    getUserUID(): number {
        return Number(localStorage.getItem('uid'));
    }

    clearSession(): void {
        this.dialog.closeAll();
        localStorage.removeItem('sessionId');
        localStorage.removeItem('firstName');
        localStorage.removeItem('lastName');
        localStorage.removeItem('username');
        localStorage.removeItem('accountType');
        localStorage.removeItem('uid');
        localStorage.removeItem('encodedPassword');
        localStorage.removeItem('rememberMe');
    }

}
